import React from "react";
import Leads from "../components/Leads";

const Home = () => {
  return <Leads />;
};

export default Home;
